import * as actionTypes from "../actionTypes";

export const getLanguage = (payload) => ({
  type: actionTypes.GET_LANGUAGE, payload
});

export const setLanguage = (payload) => ({
  type: actionTypes.SET_LANGUAGE, payload
});

export const createLanguage = (payload) => ({
  type: actionTypes.CREATE_LANGUAGE, payload
});

export const updateLanguage = (payload) => ({
  type: actionTypes.UPDATE_LANGUAGE, payload
});

export const deleteLanguage = (payload) => ({
  type: actionTypes.DELETE_LANGUAGE, payload
});